__turbopack_context__.v({
  "buttonContainer": "global-error-module__lh8QDa__buttonContainer",
  "container": "global-error-module__lh8QDa__container",
  "content": "global-error-module__lh8QDa__content",
  "description": "global-error-module__lh8QDa__description",
  "statusCode": "global-error-module__lh8QDa__statusCode",
  "title": "global-error-module__lh8QDa__title",
});
